<div class="row row-cols-lg-auto g-2 pb-3 pe-4 align-items-center">
    <label class="col-form-label-sm">Loc:</label>
    <div class="col-2">
        <select name="locCode" class="form-select form-select-sm select-m" [(ngModel)]="contractParameters.locCode">
            <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
        </select>
    </div>
    <label class="col-form-label-sm">Plan By:</label>
    <div class="col-12">
        <select name="locationType" class="form-select form-select-sm" [(ngModel)]="contractParameters.locationType">
            <option [ngValue]="0">Origin</option>
            <option [ngValue]="1">Destination</option>
        </select>
    </div>
    <div class="col-12">
        <button type="button" class="btn btn-sm btn-primary ms-1 me-1" (click)="getOpenContracts()" [disabled]="contractParameters.locCode === ''">Search</button>
    </div>
    <div *ngIf="contractParameters.locCode != ''" class="col-md d-flex ms-auto">Total: {{recordCount}}</div>
</div>

<div class="m-1">
    <div id="x" class="m-1" style="height: 400px">
        <pqgrid #contractsGrid [options]="options"></pqgrid>
    </div>
</div>
